import { createFileRoute } from '@tanstack/react-router'
import FormTemplateCreate from '../components/form-template-create/FormTemplateCreate'

export const Route = createFileRoute('/_a/templates/create')({
  component: FormTemplateCreate,
})
